export default defineNuxtRouteMiddleware((to) => {
  if (to.path === '/') {
    // Redirect to /uk
    return navigateTo('/uk');
  }
});
